import { SlideImage } from '../../../types/interfaces';
import { getPurcsUrlForImageWidth } from '../libs/purcsUrlBuilder';

import { Media } from './Media';

export class Image extends Media {
  public static readonly ZoomSize = 1800;
  public static readonly GallerySize = 816;
  public static readonly ThumbnailSize = 150;

  private constructor(
    private _thumbnail: string,
    private _gallery: string,
    private _zoom: string,
    private _alt: string | undefined
  ) {
    super();
  }

  get zoom(): string {
    return this._zoom;
  }

  get gallery(): string {
    return this._gallery;
  }

  get thumbnail(): string {
    return this._thumbnail;
  }

  get alt(): string | undefined {
    return this._alt;
  }

  copy(): Image {
    return new Image(this._thumbnail, this._gallery, this._zoom, this._alt);
  }

  equals(media: Media): boolean {
    if (!(media instanceof Image)) {
      return false;
    }
    return (
      this._thumbnail === media._thumbnail &&
      this._gallery === media._gallery &&
      this._zoom === media._zoom &&
      this._alt === media._alt
    );
  }

  static from(image: SlideImage): Image {
    return new Image(image.thumbnail, image.gallery, image.zoom, image.altText);
  }

  static fromPreviewUrl(previewUrl: string, altText: string): Image {
    const realUrl = previewUrl.startsWith('//') ? `https:${previewUrl}` : previewUrl;
    const widthReplacingRegex = /width=(\d+)/;
    const thumbnailUrl = realUrl.replace(widthReplacingRegex, `width=${Image.ThumbnailSize}`);
    const galleryUrl = realUrl.replace(widthReplacingRegex, `width=${Image.GallerySize}`);
    const zoomUrl = realUrl.replace(widthReplacingRegex, `width=${Image.ZoomSize}`);
    return new Image(thumbnailUrl, galleryUrl, zoomUrl, altText);
  }

  static fromDocument(
    tenant: string,
    locale: string,
    productKey: string,
    productVersion: number,
    altText: string | undefined,
    optionSelections: string,
    instructionsUri: string,
    purpose: string
  ): Image {
    return new Image(
      getPurcsUrlForImageWidth(
        tenant,
        locale,
        productKey,
        productVersion,
        optionSelections,
        instructionsUri,
        purpose,
        Image.ThumbnailSize
      ),
      getPurcsUrlForImageWidth(
        tenant,
        locale,
        productKey,
        productVersion,
        optionSelections,
        instructionsUri,
        purpose,
        Image.GallerySize
      ),
      getPurcsUrlForImageWidth(
        tenant,
        locale,
        productKey,
        productVersion,
        optionSelections,
        instructionsUri,
        purpose,
        Image.ZoomSize
      ),
      altText || ''
    );
  }
}
